import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69cb81a6c3f8480013f4d454/habitlab/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69cb81a6c3f8480013f4d454/habitlab/src/components/Header.tsx");
